import { isSpSize } from "../../common/utils/isSpSize";
import MathUtil from "../../common/utils/MathUtil";

class Particle extends PIXI.Container {
  // ---------------------------------------------------------------------------
  // --	Particle
  // ---------------------------------------------------------------------------

  constructor(whFlag = false) {
    super();

    //パーティクル読み込み
    const filename = whFlag ? "blur_wh.png" : "blur.png";
    const particle = new PIXI.Sprite.from("/assets/img/home/" + filename);
    particle.anchor.set(0.5, 0.5);
    this.addChild(particle);
  }

  /**
   * ランダムな動き
   */
  randomMove(min = 50, max = 200) {
    //ランダムな位置
    const distance = min + Math.random() * (max - min);
    const radian = MathUtil.degreeToRadian(Math.random() * 360);
    const opX = Math.cos(radian) * distance;
    const opY = Math.sin(radian) * distance;

    //TWEEN
    gsap.killTweensOf(this);
    gsap.to(this, {
      duration: 2 + (Math.random() * 200) / 100,
      x: opX,
      y: opY,
      ease: "power1.inOut",
      onComplete: () => {
        this.randomMove(min, max);
      },
    });
  }

  /**
   * ランダムな動きを停止
   */
  stop() {
    gsap.killTweensOf(this);
  }

  // ---------------------------------------------------------------------------
  // --	サイズ
  // ---------------------------------------------------------------------------

  setScaleByPX(width) {
    const scale = width / 785;
    this.setScale(scale);
  }

  setScale(scale) {
    this.scale.set(scale, scale);
  }

  // ---------------------------------------------------------------------------
}

export default Particle;
